import { ErrorBoundary } from '../components/error/ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
export const withErrorBoundary = (WrappedComponent, fingerprint) => {
  function WithErrorBoundary(props) {
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      fingerprint: fingerprint,
      children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props))
    });
  }
  return WithErrorBoundary;
};